<template>
  <div class="filter-selects">
    <vue-select
      v-if="activeSelectEquipes"
      :options="equipes"
      :get-option-label="getCustomLabel"
      placeholder="Equipes"
      @input="handleEquipe"
    >
      <template v-if="!customLabel" slot="option" slot-scope="option">
        {{ option.no_equipe }}
        {{
          option.nu_ine != 'sem-equipe'
            ? '- ' + option[`ine_${tipoEquipe}`]
            : ''
        }}
      </template>
      <template v-else slot="option" slot-scope="option">
        {{ option[customLabelItem.no_equipe] }}
        -
        {{ option[customLabelItem.tipo_equipe] }}
      </template>
      <div slot="no-options">Não há opções correspondentes</div>
    </vue-select>
    <vue-select
      v-if="activeSelectMicroArea"
      :options="microareas"
      label="micro_area"
      placeholder="Microárea"
      @input="handleMicroArea"
      :loading="loadingSelectMicroAreas"
      :disabled="disabledSelectMicroAreas"
      v-model="microarea"
    >
      <template slot="option" slot-scope="option">
        {{ option.micro_area }}
      </template>
      <div slot="no-options">Não há opções correspondentes</div>
    </vue-select>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import utils from '@/mixins/utils.js'

export default {
  name: 'SelectsV2',
  components: {
    VueSelect,
  },
  mixins: [utils],
  props: {
    activeSelectEquipes: {
      type: Boolean,
      default: true,
    },
    callbackOnChangeEquipe: {
      type: [Function, Boolean],
      default: false,
    },
    activeOptionSemEquipe: {
      type: Boolean,
      default: false,
    },
    activeSelectMicroArea: {
      type: Boolean,
      default: false,
    },
    callbackOnChangeMicroArea: {
      type: [Function, Boolean],
      default: false,
    },
    tipoEquipe: {
      type: String,
      default: 'esf_eap',
    },
    customLabel: {
      type: Boolean,
      default: false,
    },
    customLabelItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      profissional: null,
      profissionais: [],
      microarea: null,
      microareas: [],
      loadingSelectMicroAreas: false,
      disabledSelectMicroAreas: false,
    }
  },
  computed: {
    equipes() {
      const tipo = this.tipoEquipe // 'esb', 'esf_eap', 'emulti'
      const dataOriginal = this.$store.state.equipesV2 || []

      if (this.customLabel) {
        return dataOriginal.filter((el) => {
          return el[this.customLabelItem.tipo_equipe] != null
        })
      }

      let seen = new Set()

      let data = dataOriginal
        .filter((item) =>
          Object.keys(item).some((key) => key.includes(tipo) && item[key])
        )
        .map((item) => {
          const ineKey = Object.keys(item).find(
            (key) => key.includes(`ine_${tipo}`) && item[key]
          )
          const nomeKey = Object.keys(item).find(
            (key) => key.includes(`no_${tipo}`) && item[key]
          )

          return {
            ine_esf_eap: item.ine_esf_eap,
            [`ine_${tipo}`]: ineKey ? item[ineKey] : '',
            no_equipe: nomeKey ? item[nomeKey] : '',
            nu_cnes: item.nu_cnes,
          }
        })
        .filter((item) => {
          const key = item[`ine_${tipo}`]
          if (seen.has(key)) {
            return false
          }
          seen.add(key)
          return true
        })

      return data
    },
  },
  async mounted() {
    if (this.activeSelectEquipes == false) {
      let nu_ine_profissional =
        this.$store.state.id_funcao == 8 ||
        this.$store.state.id_funcao == 14 ||
        this.$store.state.id_funcao == 15
          ? this.$store.state.nu_ine_vinculada
          : this.$store.state.nu_ine
      await this.carregarMicroAreasPorEquipe(nu_ine_profissional)
    }
  },
  methods: {
    /**
     * Retorna o texto que será exibido no componente de seleção da equipe.
     *
     * @param {Object} option Dados da equipe.
     * @returns {String} Texto formatado para exibição.
     */
    getCustomLabel(option) {
      if (!this.customLabel) return option.no_equipe
      return `${option[this.customLabelItem.no_equipe]} - ${
        option[this.customLabelItem.tipo_equipe]
      }`
    },

    /**
     * Atualiza a equipe selecionada, carregando as microáreas quando
     * habilitadas e disparando o callback correspondente.
     *
     * @async
     * @param {Object|null} val Equipe selecionada.
     * @returns {Promise<void>}
     */
    async handleEquipe(val) {
      try {
        this.profissional = null
        this.microarea = null
        if (val != null) {
          // carrega as microareas
          if (this.activeSelectMicroArea) {
            await this.carregarMicroAreasPorEquipe(val.ine_esf_eap)
          }
        }
        this.callbackOnChangeEquipe(val)
      } catch (error) {
        console.log(error)
      }
    },

    /**
     * Atualiza a microárea selecionada, limpando o profissional atual e
     * disparando o callback correspondente.
     *
     * @param {Object|null} val Microárea selecionada.
     * @returns {void}
     */
    handleMicroArea(val) {
      this.profissional = null
      this.callbackOnChangeMicroArea(val)
    },

    /**
     * Carrega as microáreas da equipe selecionada utilizando os dados
     * armazenados localmente no Vuex.
     *
     * @async
     * @param {String} nu_ine Identificador INE da equipe.
     * @returns {Promise<void>}
     */
    async carregarMicroAreasPorEquipe(nu_ine) {
      let equipe = this.$store.state.equipesV2.find((el) => {
        return (
          el.ine_emulti == nu_ine ||
          el.ine_esb == nu_ine ||
          el.ine_esf_eap == nu_ine
        )
      })

      if (equipe == undefined) {
        this.microareas = []
        return
      }

      let ine = ''
      if (equipe.ine_emulti == nu_ine) {
        ine = equipe.ine_emulti
      }
      if (equipe.ine_esb == nu_ine) {
        ine = equipe.ine_esb
      }
      if (equipe.ine_esf_eap == nu_ine) {
        ine = equipe.ine_esf_eap
      }

      this.loadingSelectMicroAreas = true
      this.disabledSelectMicroAreas = true
      let microAreas = this.$store.state.microAreas
      if (microAreas != null) {
        this.microareas = microAreas
          .filter((item) => {
            return item.ine_fci === ine
          })
          .map((item) => ({ micro_area: item.micro_area }))
      } else {
        this.microareas = []
      }
      this.disabledSelectMicroAreas = false
      this.loadingSelectMicroAreas = false
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-selects {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin: 10px auto 30px;
  .v-select {
    flex: 0 1 33%;
    font-size: 14px;
    .vs__dropdown-toggle {
      /* background-color: #fff; */
      padding: 5px;
    }
  }
}

@media screen and (max-width: 656px) {
  .filter-selects {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .filter-selects {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .filter-selects {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>

<style lang="scss">
.filter-selects {
  .v-select {
    .vs__dropdown-toggle {
      height: 45px;
    }
  }
}
</style>
